import Collapse from '@anm/components/Collapse';
import { FC } from 'react';
import { NewDestination, SocialDestination } from 'types/stream';

import getBrokenDestinations, { DestinationWithWarning } from '../helpers/getBrokenDestinations';
import CollapseTarget from './CollpaseTarget';
import ErrorDestinations from './ErrorList';
import WarningDestinations from './WarningList';

import { Wrapper } from './Wrapper';

type DestinationWarningProps = {
  list?: SocialDestination[];
  destinations: NewDestination[];
};

const canCollapse = (list: SocialDestination[] | DestinationWithWarning[] = []) => list.length > 2;

const DestinationWarning: FC<DestinationWarningProps> = ({ list, destinations }) => {
  const [destinationsWithError, destinationWithWarning] = getBrokenDestinations(list);

  const canRenderErrors = !!destinationsWithError?.length;
  const canRenderWarnings = !!destinationWithWarning?.length;

  if (!canRenderErrors && !canRenderWarnings) return null;

  return (
    <Wrapper>
      {canRenderErrors && (
        <>
          {canCollapse(destinationsWithError) ? (
            <Collapse
              variant="up-down-small-arrow"
              renderTarget={() => <CollapseTarget variant="danger" count={destinationsWithError?.length} />}
              renderContent={() => <ErrorDestinations {...{ destinations, destinationsWithError }} />}
            />
          ) : (
            <ErrorDestinations {...{ destinations, destinationsWithError }} />
          )}
        </>
      )}

      {canRenderWarnings && (
        <>
          {canCollapse(destinationWithWarning) ? (
            <Collapse
              variant="up-down-small-arrow"
              renderTarget={() => <CollapseTarget variant="warning" count={destinationWithWarning?.length} />}
              renderContent={() => <WarningDestinations {...{ destinations, destinationWithWarning }} />}
            />
          ) : (
            <WarningDestinations {...{ destinations, destinationWithWarning }} />
          )}
        </>
      )}
    </Wrapper>
  );
};

export default DestinationWarning;
